/** Mensaje alcanzar tope de usuarios (alineado con backend license_authorized_limits). */
export const MSG_LICENSE_USER_LIMIT =
  "Has alcanzado el límite de usuarios autorizados para esta licencia. Solicita una ampliación a BNT.";

export function resolveLicenseUserCap(systemInfo) {
  const raw =
    systemInfo?.license?.authorized_users ?? systemInfo?.license?.payload?.authorized_users;
  if (raw == null || Number(raw) <= 0) {
    return { enforced: false, cap: null };
  }
  return { enforced: true, cap: Number(raw) };
}

export function resolveLicenseClientCap(systemInfo) {
  const raw =
    systemInfo?.license?.authorized_clients ?? systemInfo?.license?.payload?.authorized_clients;
  if (raw == null || Number(raw) <= 0) {
    return { enforced: false, cap: null };
  }
  return { enforced: true, cap: Number(raw) };
}

export function isWorkspaceUserActive(user) {
  const st = user?.workspace_status ?? user?.despacho_profile?.status ?? "active";
  return String(st).toLowerCase() !== "inactive";
}

export function countActiveWorkspaceUsers(users = []) {
  return (users || []).filter(isWorkspaceUserActive).length;
}

export function computeUserSlotStats(systemInfo, users = []) {
  const { enforced, cap } = resolveLicenseUserCap(systemInfo);
  const active = countActiveWorkspaceUsers(users);
  const authorized = enforced && cap != null ? cap : null;
  const available = authorized != null ? Math.max(0, authorized - active) : null;
  return {
    authorized,
    active,
    available,
    enforced,
    atLimit: authorized != null && active >= authorized,
    canAddUser: authorized == null || active < authorized,
  };
}

export function computeClientSlotStats(systemInfo, activeClients = null) {
  const { enforced, cap } = resolveLicenseClientCap(systemInfo);
  const active = activeClients != null ? Number(activeClients) : null;
  const authorized = enforced && cap != null ? cap : null;
  const available = authorized != null && active != null ? Math.max(0, authorized - active) : null;
  return { authorized, active, available, enforced };
}

export function canUseBasicTeamFeatures(systemInfo) {
  const { cap, enforced } = resolveLicenseUserCap(systemInfo);
  if (!enforced || cap == null) return true;
  return cap > 1;
}
